import React, {Component} from 'react';
import './IRealestate.css';
import IndustryIndividualCard from '../Components/IndustryIndividualCard/IndustryIndividualCard.js'
import realEstateCover from '../../../images/individual/realestate/RealEstateCover.jpg';
import realEstateImg1 from '../../../images/individual/realestate/RE2.jpg';
import realEstateImg2 from '../../../images/individual/realestate/RE4.png';
import realEstateImg3 from '../../../images/individual/realestate/DNB4.jpg';

export default class IRealestate extends Component {
	render() {
		return (
			<div className="i_realestate_container">
				<div className="i_realestate_container_cover_text">REAL ESTATE</div>
				<div className="i_realestate_container_cover_image"><img src={realEstateCover} /></div>
				<div className="i_realestate_subtitle">
					<span>PPI has an unparalleled ability to make a significant and positive impact in Asia-Pacific through its world class investment management team.</span>
				</div>
				<div className="i_realestate_content">
					<IndustryIndividualCard
						link='/realestate/design'
						clickable={true}
						moreEnabled = 'true'
						image={realEstateImg1}
						title='DESIGN & BUILD CONTRACTS'
						description1='The offering of comprehensive Design & Build package in an integrated approach from design inputs to final physical construction stage, bringing good value and high quality to our projects, especially in Singapore market.'
						description2='Through our Singapore office, we provide a full range of integrated Design & Build Contracts, which includes creative solutions, single source risk management, vertical integration, multi-disciplinary team, high integrity and commitment towards our clients’ needs.'
					/>
					<IndustryIndividualCard
						link='/realestate/investment'
						clickable={true}
						moreEnabled = 'true'
						image={realEstateImg3}
						title='PROPERTY INVESTMENT'
						description1='Our Objective for property Investment is for mid & long terms, seeking investments in properties and land banks with good potentials for redevelopment. PPI has become synonymous with transforming commercial spaces in the city centre location into other usage like healthcare building development.'
						description2='PPI invested in various overseas markets real estate assets in cities such as United Kingdom, Singapore, Cambodia Gold and Australia'
					/>
					<IndustryIndividualCard
						link='/realestate/advisory'
						clickable={true}
						moreEnabled = 'true'
						image={realEstateImg2}
						title='ADVISORY ON REAL ESTATE'
						description1='Together with our selected Consortium associates we identify and inception of attractive property development projects especially in emerging market in Myanmar, Indonesia, Vietnam. We source good potentials Real Estate Investment, in residential, commercial, and industrial. '
						description2='With our feasibility analysis, we project the return on Investment, create value throughout the lifecycle of a real estate project. Value creation has become increasingly important to our clients.'
					/>
				</div>
			</div>
		);
	}
}
